import React, { Component } from "react";

type AppIconProps = {
  name: string;
  size?: number;
  color?: string;
  style?: React.CSSProperties;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLSpanElement>;
};

export class AppIcon extends Component<AppIconProps> {

  static defaultProps = {
    size: 24,
    color: "inherit",
  };

  render() {
    const { name, size, color, style, className, onClick } = this.props;

    return (
      <span
        className={`material-symbols-outlined ${className || ""}`}
        style={{
          fontSize: size,
          color,
          lineHeight: 1,
          verticalAlign: "middle",
          ...style,
        }}
        onClick={onClick}
      >
        {name}
      </span>
    );
  }
}
